import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './AppRoutes';
import { ProfileHelper } from '../helpers/ProfileHelper';
import { useAuth } from '../contexts/AuthContext';
import Home from '../pages/Home/Home';
import Login from '../pages/Login/Login';
import OrdersWithDegree from '../pages/OrdersWithDegree/OrdersWithDegree';
import OrdersNonDegree from '../pages/OrdersNonDegree/OrdersNonDegree';
import OrdersHomeTryOn from '../pages/OrdersHomeTryOn/OrdersHomeTryOn';
import Reports from '../pages/Reports/Reports';
import ManageTransport from '../pages/ManageTransport/ManageTransport';
import ManageDnpLinks from '../pages/ManageDnpLinks/ManageDnpLinks';
import ManagePendingInvoicingOrders from '../pages/ManagePendingInvoicingOrders/ManagePendingInvoicingOrders';
import ManageLocations from '../pages/ManageLocations/ManageLocations';
import ManageCustomers from '../pages/ManageCustomers/ManageCustomers';
import ManageAmaroIntegrations from '../pages/ManageAmaroIntegrations/ManageAmaroIntegrations';
import ListAmaroOrderImports from '../pages/ListAmaroOrderImports/ListAmaroOrderImports';
import AppConfigs from '../pages/AppConfigs/AppConfigs';
import ExpressOrders from '../pages/ExpressOrders/ExpressOrders';
import ExpressOrdersNonDegree from '../pages/ExpressOrdersNonDegree/ExpressOrdersNonDegree';
import ExpressOrdersWithDegree from '../pages/ExpressOrdersWithDegree/ExpressOrdersWithDegree';

const ProtectedRoutes: React.FC = () => {

  const { session } = useAuth();

  const list = [
    <Route key={routes.Login} path={routes.Login} element={<Login />} />,
    <Route key={routes.Index} path={routes.Index} element={<Home />} />,
    <Route key={routes.OrdersWithDegree} path={routes.OrdersWithDegree} element={<OrdersWithDegree />} />,
    <Route key={routes.OrdersNonDegree} path={routes.OrdersNonDegree} element={<OrdersNonDegree />} />,
    <Route key={routes.OrdersHomeTryOn} path={routes.OrdersHomeTryOn} element={<OrdersHomeTryOn />} />,
    <Route key={routes.Reports} path={routes.Reports} element={<Reports />} />,
    <Route key={routes.ManageDnpLinks} path={routes.ManageDnpLinks} element={<ManageDnpLinks />} />,
    <Route key={routes.Customers} path={routes.Customers} element={<ManageCustomers />} />,
    <Route key={routes.ManageAmaroIntegrations} path={routes.ManageAmaroIntegrations} element={<ManageAmaroIntegrations />} />,
    <Route key={routes.ListAmaroOrderImports} path={routes.ListAmaroOrderImports} element={<ListAmaroOrderImports />} />,
    <Route key={routes.AppConfigs} path={routes.AppConfigs} element={<AppConfigs />} />,
    <Route key={routes.ExpressOrders} path={routes.ExpressOrders} element={<ExpressOrders />} />,
    <Route key={routes.ExpressOrdersNonDegree} path={routes.ExpressOrdersNonDegree} element={<ExpressOrdersNonDegree />} />,
    <Route key={routes.ExpressOrdersWithDegree} path={routes.ExpressOrdersWithDegree} element={<ExpressOrdersWithDegree />} />,
  ];

  if (ProfileHelper.profilesThatCanViewTransport.some(p => p === session?.user?.profileType)) {
    list.push(<Route key={routes.ManageTransport} path={routes.ManageTransport} element={<ManageTransport />} />);
  }

  if (ProfileHelper.profilesThatCanViewPendingInvoicingOrders.some(p => p === session?.user?.profileType)) {
    list.push(<Route key={routes.ManagePendingInvoicingOrders} path={routes.ManagePendingInvoicingOrders} element={<ManagePendingInvoicingOrders />} />);
  }

  // sem perfil admin a rota não existe e cai no "*" abaixo, que redireciona para a home
  if (ProfileHelper.profilesThatCanManageLocations.some(p => p === session?.user?.profileType)) {
    list.push(<Route key={routes.ManageLocations} path={routes.ManageLocations} element={<ManageLocations />} />);
  }

  return (
    <Routes>
      {list}

      <Route
        path="*"
        element={<Navigate to="/" />}
      />
    </Routes>
  );
};

export default ProtectedRoutes;